<template>
  <div ref="dressCodeRef" class="dresscode-container">

    <h2 ref="tituloRef" class="titulo">
      DRESS CODE
    </h2>

    <p ref="subtituloRef" class="formal">
      FORMAL
    </p>

    <!-- ÍCONO -->
    <div class="icono-container">
      <img
        ref="parejaRef"
        src="@/assets/dresscode.svg"
        alt="Dress code elegante"
      />
    </div>

    <!-- TEXTO -->
    <p ref="p2Ref" class="descripcion colores-reservados">
      Reservamos el color Blanco exclusivamente para la novia y el Verde Olivo para las damas.
    </p>

    <!-- IDEAS -->
    <div ref="ideasRef" class="ideas-container">

      <!-- MUJERES 
      <a
        class="idea-link"
        href="https://mx.pinterest.com/pin/2533343538928127/"
        target="_blank"
        rel="noopener"
      >
        Mujeres — Ideas
      </a>-->

      <!-- HOMBRES
      <a
        class="idea-link"
        href="https://mx.pinterest.com/pin/4644405861031428/"
        target="_blank"
        rel="noopener"
      >
        Hombres — Ideas
      </a>
 -->
    </div>

  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'

export default {

  name: 'DressCode',

  setup() {

    const dressCodeRef = ref(null)

    const tituloRef = ref(null)
    const subtituloRef = ref(null)
    const p2Ref = ref(null)

    const parejaRef = ref(null)
    const ideasRef = ref(null)

    onMounted(() => {

      const observer = new IntersectionObserver(

        (entries) => {

          entries.forEach((entry) => {

            if (entry.isIntersecting) {

              const tl = gsap.timeline({
                defaults: {
                  ease: 'power2.out'
                }
              })

              tl.fromTo(
                tituloRef.value,
                {
                  opacity: 0,
                  y: -20
                },
                {
                  opacity: 1,
                  y: 0,
                  duration: 0.5
                }
              )

              .fromTo(
                subtituloRef.value,
                {
                  opacity: 0,
                  y: 15
                },
                {
                  opacity: 1,
                  y: 0,
                  duration: 0.5
                },
                '-=0.2'
              )

              .fromTo(
                parejaRef.value,
                {
                  opacity: 0,
                  scale: 0.92
                },
                {
                  opacity: 1,
                  scale: 1,
                  duration: 0.7
                },
                '-=0.2'
              )

              .fromTo(
                p2Ref.value,
                {
                  opacity: 0,
                  y: 15
                },
                {
                  opacity: 1,
                  y: 0,
                  duration: 0.5
                },
                '-=0.3'
              )

              .fromTo(
                ideasRef.value.children,
                {
                  opacity: 0,
                  y: 20
                },
                {
                  opacity: 1,
                  y: 0,
                  stagger: 0.15,
                  duration: 0.5
                },
                '-=0.2'
              )

              observer.unobserve(entry.target)

            }

          })

        },

        {
          threshold: 0.25
        }

      )

      observer.observe(dressCodeRef.value)

    })

    return {

      dressCodeRef,

      tituloRef,
      subtituloRef,
      p2Ref,

      parejaRef,
      ideasRef

    }

  }

}
</script>

<style scoped>

.dresscode-container {

  background-color: #f2eee8;

  color: #1a1a1a;

  text-align: center;

  padding: 70px 20px;

  font-family: 'Playfair Display', serif;

  overflow: hidden;
}

/* TITULO */

.titulo {

  font-size: 30px;

  letter-spacing: 4px;

  color: #1a1a1a;

  margin-bottom: 0;

  font-weight: 500;

  opacity: 0;
}

/* FORMAL */

.formal {

  font-size: 15px;

  font-family: 'Poppins', sans-serif;

  font-style: italic;

  margin-top: 10px;

  margin-bottom: 25px;

  letter-spacing: 3px;

  opacity: 0;
}

/* ICONO */

.icono-container img {

  width: 220px;

  margin: 10px auto 28px;

  opacity: 0;

  filter: brightness(0.55);
}

/* TEXTO */

.descripcion {

  font-size: 17px;

  font-family: 'Playfair Display', serif;

  line-height: 1.8;

  color: #2d2d2d;

  max-width: 480px;

  margin: 0 auto;

  opacity: 0;
}

.colores-reservados {

  font-size: 15px;
}

/* IDEAS */

.ideas-container {

  margin-top: 28px;

  display: flex;

  flex-direction: column;

  gap: 14px;

  align-items: center;
}

/* LINKS ELEGANTES */

.idea-link {

  display: inline-flex;

  align-items: center;

  justify-content: center;

  padding: 12px 28px;

  border: 1px solid rgba(26,26,26,0.18);

  border-radius: 50px;

  background: rgba(255,255,255,0.35);

  backdrop-filter: blur(8px);

  text-decoration: none;

  color: #1a1a1a;

  font-family: 'Playfair Display', serif;

  font-size: 17px;

  letter-spacing: 1px;

  opacity: 0;

  transition: all 0.35s ease;

  box-shadow:
    0 8px 25px rgba(0,0,0,0.04);
}

.idea-link:hover {

  transform: translateY(-3px);

  letter-spacing: 2px;

  background: rgba(255,255,255,0.6);

  box-shadow:
    0 14px 30px rgba(0,0,0,0.08);
}

.idea-link::after {

  content: '';

  position: absolute;

  left: 50%;

  bottom: -4px;

  width: 0%;

  height: 1px;

  background: #1a1a1a;

  transform: translateX(-50%);

  transition: 0.4s ease;
}

.idea-link:hover {

  letter-spacing: 2px;
}

.idea-link:hover::after {

  width: 100%;
}

/* MOBILE */

@media (max-width: 768px) {

  .titulo {

    font-size: 28px;
  }

  .descripcion {

    font-size: 15px;

    line-height: 1.7;
  }

  .icono-container img {

    width: 200px;
  }

}

</style>